import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b1c6ed5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "df jc-right" }
const _hoisted_4 = { style: {"display":"flex","align-items":"flex-end"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"200px"} }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_7 = { class: "case-nav" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tablet-add" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close-light" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "d-main" }
const _hoisted_14 = { class: "d-main__info" }
const _hoisted_15 = { style: {"display":"flex","align-items":"flex-end"} }
const _hoisted_16 = { class: "d-main__media" }
const _hoisted_17 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_drive_input = _resolveComponent("drive-input")!
  const _component_drive_create_case_files = _resolveComponent("drive-create-case-files")!
  const _component_app_label_input = _resolveComponent("app-label-input")!
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_skeleton_case_view = _resolveComponent("app-skeleton-case-view")!
  const _component_upload_files_pop_up = _resolveComponent("upload-files-pop-up")!
  const _component_upload_photos_pop_up = _resolveComponent("upload-photos-pop-up")!
  const _component_drive_add_files = _resolveComponent("drive-add-files")!
  const _component_drive_add_photos = _resolveComponent("drive-add-photos")!
  const _component_drive_create_case_cancel_pop_up = _resolveComponent("drive-create-case-cancel-pop-up")!
  const _component_desktop_upload_progress = _resolveComponent("desktop-upload-progress")!
  const _component_drive_desktop_add_files = _resolveComponent("drive-desktop-add-files")!
  const _component_drive_desktop_add_photos = _resolveComponent("drive-desktop-add-photos")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["pop", {'fullscreen-pop': _ctx.photos}])
      }, [
        _createVNode(_component_app_header, { countPadding: "" }, {
          "top-left": _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateBackAction && _ctx.validateBackAction(...args)), ["prevent"])),
              class: "back-link"
            }, _hoisted_2)
          ]),
          "top-right": _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createCase && _ctx.createCase(...args))),
                class: _normalizeClass(["link", { disabled: _ctx.isDoneDisabled }])
              }, " Save ", 2)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_drive_input, {
          title: _ctx.$localize('edit.case.title'),
          placeholder: _ctx.$localize('edit.case.title.placeholder'),
          modelValue: _ctx.createCasePayload.title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createCasePayload.title) = $event)),
          hideBorder: _ctx.validation.title ? _ctx.HIDE_BORDER.NONE : _ctx.HIDE_BORDER.BOTTOM,
          error: _ctx.validation.title,
          onInput: _ctx.validateCaseTitle,
          enterkeyhint: "",
          "disabled-enter": ""
        }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_drive_input, {
            class: "case-description",
            title: _ctx.$localize('edit.case.description.title'),
            placeholder: _ctx.$localize('edit.case.description.placeholder'),
            modelValue: _ctx.createCasePayload.description,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createCasePayload.description) = $event)),
            hideBorder: _ctx.HIDE_BORDER.BOTTOM,
            error: _ctx.validation.description,
            onInput: _ctx.validateCaseDescription
          }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"])
        ]),
        _createVNode(_component_drive_create_case_files, {
          "temporary-files": _ctx.previewPhotos,
          title: _ctx.$localize('edit.case.media.type.photo'),
          hideBorder: _ctx.HIDE_BORDER.BOTTOM,
          "skeleton-amount": _ctx.mediaSkeletons.photos,
          onRemoveFile: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeUploadedFile($event, true))),
          onOpenUploadPopUp: _cache[5] || (_cache[5] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.UPLOAD_PHOTOS)),
          isPhoto: ""
        }, null, 8, ["temporary-files", "title", "hideBorder", "skeleton-amount"]),
        _createVNode(_component_drive_create_case_files, {
          "temporary-files": _ctx.previewFiles,
          title: _ctx.$localize('edit.case.media.type.file'),
          hideBorder: _ctx.HIDE_BORDER.BOTTOM,
          "skeleton-amount": _ctx.mediaSkeletons.files,
          onRemoveFile: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeUploadedFile($event, false))),
          onOpenUploadPopUp: _cache[7] || (_cache[7] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.UPLOAD_FILES))
        }, null, 8, ["temporary-files", "title", "hideBorder", "skeleton-amount"]),
        _createVNode(_component_drive_ui_wrapper, {
          title: _ctx.$localize('edit.case.labels'),
          hideBorder: _ctx.HIDE_BORDER.BOTTOM,
          id: 'labelsInput'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_label_input, {
              onOnUpdateTags: _ctx.updateTags,
              onOnFocus: _ctx.setFocusOnLabels
            }, null, 8, ["onOnUpdateTags", "onOnFocus"])
          ]),
          _: 1
        }, 8, ["title", "hideBorder"]),
        _createVNode(_component_app_button, {
          onClick: _ctx.createCase,
          class: _normalizeClass(["save-button", { disabled: _ctx.isDoneDisabled }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('edit.case.done.button')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "class"]),
        _hoisted_5,
        (_ctx.isCaseCreating)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
              key: 0,
              title: _ctx.createCasePayload.title,
              "file-skeletons": _ctx.previewFiles.length,
              "photo-skeletons": _ctx.previewPhotos.length
            }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.UPLOAD_FILES)
            ? (_openBlock(), _createBlock(_component_upload_files_pop_up, {
                key: 0,
                onAddFiles: _cache[8] || (_cache[8] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_FILES)),
                onUploadFiles: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onUploadMedia($event, false))),
                onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
                customControl: ""
              }))
            : _createCommentVNode("", true),
          (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.UPLOAD_PHOTOS)
            ? (_openBlock(), _createBlock(_component_upload_photos_pop_up, {
                key: 1,
                onAddPhotos: _cache[11] || (_cache[11] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_PHOTOS)),
                onUploadPhotos: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onUploadMedia($event, true))),
                onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
                customControl: ""
              }))
            : _createCommentVNode("", true)
        ])),
        (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_FILES)
          ? (_openBlock(), _createBlock(_component_drive_add_files, {
              key: 1,
              onAddSelectedFiles: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSelectMedia($event, false))),
              onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
              customControl: "",
              "temporary-files": _ctx.previewFiles
            }, null, 8, ["temporary-files"]))
          : _createCommentVNode("", true),
        (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_PHOTOS)
          ? (_openBlock(), _createBlock(_component_drive_add_photos, {
              key: 2,
              onAddSelectedPhotos: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSelectMedia($event, true))),
              onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
              customControl: "",
              "temporary-files": _ctx.previewPhotos
            }, null, 8, ["temporary-files"]))
          : _createCommentVNode("", true),
        (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.CANCEL)
          ? (_openBlock(), _createBlock(_component_drive_create_case_cancel_pop_up, {
              key: 3,
              onOnAccept: _ctx.uploadFilesToDrive,
              onOnCancel: _ctx.backAction
            }, null, 8, ["onOnAccept", "onOnCancel"]))
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('drive.button.add.case')), 1)
          ]),
          _createElementVNode("div", {
            class: "cancel-button",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)))
          }, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.mainStore.uploadInfos.length)
            ? (_openBlock(), _createBlock(_component_desktop_upload_progress, {
                key: 0,
                uploadInfo: _ctx.mainStore.getUploadInfo
              }, null, 8, ["uploadInfo"]))
            : _createCommentVNode("", true),
          (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.UPLOAD_FILES)
            ? (_openBlock(), _createBlock(_component_upload_files_pop_up, {
                key: 1,
                onAddFiles: _cache[19] || (_cache[19] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_FILES)),
                onUploadFiles: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onUploadMedia($event, false))),
                onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
                "files-pop-up-pos": _ctx.filesPopUpPos,
                customControl: ""
              }, null, 8, ["files-pop-up-pos"]))
            : (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_FILES)
              ? (_openBlock(), _createBlock(_component_drive_desktop_add_files, {
                  key: 2,
                  onAddSelectedFiles: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onSelectMedia($event, false))),
                  onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
                  customControl: "",
                  "temporary-files": _ctx.previewFiles
                }, null, 8, ["temporary-files"]))
              : (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.UPLOAD_PHOTOS)
                ? (_openBlock(), _createBlock(_component_upload_photos_pop_up, {
                    key: 3,
                    onAddPhotos: _cache[24] || (_cache[24] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_PHOTOS)),
                    onUploadPhotos: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onUploadMedia($event, true))),
                    onClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
                    "photos-pop-up-pos": _ctx.photosPopUpPos,
                    customControl: ""
                  }, null, 8, ["photos-pop-up-pos"]))
                : (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.ADD_PHOTOS)
                  ? (_openBlock(), _createBlock(_component_drive_desktop_add_photos, {
                      key: 4,
                      onAddSelectedPhotos: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onSelectMedia($event, true))),
                      onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.popUpManager = _ctx.CASE_CREATION_POP_UP_SWITCHER.NONE)),
                      customControl: "",
                      "temporary-files": _ctx.previewPhotos
                    }, null, 8, ["temporary-files"]))
                  : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_drive_input, {
              title: _ctx.$localize('edit.case.title'),
              placeholder: _ctx.$localize('edit.case.title.placeholder'),
              modelValue: _ctx.createCasePayload.title,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.createCasePayload.title) = $event)),
              hideBorder: _ctx.HIDE_BORDER.TOP,
              error: _ctx.validation.title,
              onInput: _ctx.validateCaseTitle,
              enterkeyhint: "",
              "disabled-enter": ""
            }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_drive_input, {
                class: "case-description",
                title: _ctx.$localize('edit.case.description.title'),
                placeholder: _ctx.$localize('edit.case.description.placeholder'),
                modelValue: _ctx.createCasePayload.description,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.createCasePayload.description) = $event)),
                hideBorder: _ctx.HIDE_BORDER.TOP,
                error: _ctx.validation.description,
                onInput: _ctx.validateCaseDescription
              }, null, 8, ["title", "placeholder", "modelValue", "hideBorder", "error", "onInput"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_drive_create_case_files, {
                "temporary-files": _ctx.previewPhotos,
                title: _ctx.$localize('edit.case.media.type.photo'),
                hideBorder: _ctx.HIDE_BORDER.TOP,
                "skeleton-amount": _ctx.mediaSkeletons.photos,
                onRemoveFile: _cache[31] || (_cache[31] = ($event: any) => (_ctx.removeUploadedFile($event, true))),
                onOpenUploadPopUp: _ctx.addPhotos,
                isPhoto: ""
              }, null, 8, ["temporary-files", "title", "hideBorder", "skeleton-amount", "onOpenUploadPopUp"]),
              _createVNode(_component_drive_create_case_files, {
                "temporary-files": _ctx.previewFiles,
                title: _ctx.$localize('edit.case.media.type.file'),
                hideBorder: _ctx.HIDE_BORDER.TOP,
                "skeleton-amount": _ctx.mediaSkeletons.files,
                onRemoveFile: _cache[32] || (_cache[32] = ($event: any) => (_ctx.removeUploadedFile($event, false))),
                onOpenUploadPopUp: _ctx.addFiles
              }, null, 8, ["temporary-files", "title", "hideBorder", "skeleton-amount", "onOpenUploadPopUp"]),
              _createVNode(_component_drive_ui_wrapper, {
                title: _ctx.$localize('edit.case.labels'),
                hideBorder: _ctx.HIDE_BORDER.TOP
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_label_input, {
                    onOnUpdateTags: _ctx.updateTags,
                    onOnFocus: _ctx.setFocusOnLabels
                  }, null, 8, ["onOnUpdateTags", "onOnFocus"])
                ]),
                _: 1
              }, 8, ["title", "hideBorder"])
            ]),
            _createVNode(_component_app_button, {
              onClick: _ctx.createCase,
              class: _normalizeClass(["d-save-button", { disabled: _ctx.isDoneDisabled }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('edit.case.done.button')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "class"])
          ]),
          (_ctx.isCaseCreating)
            ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
                key: 5,
                title: _ctx.createCasePayload.title,
                "file-skeletons": _ctx.previewFiles.length,
                "photo-skeletons": _ctx.previewPhotos.length
              }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
            : (_ctx.popUpManager === _ctx.CASE_CREATION_POP_UP_SWITCHER.CANCEL)
              ? (_openBlock(), _createBlock(_component_drive_create_case_cancel_pop_up, {
                  key: 6,
                  onOnAccept: _ctx.uploadFilesToDrive,
                  onOnCancel: _ctx.backAction
                }, null, 8, ["onOnAccept", "onOnCancel"]))
              : _createCommentVNode("", true)
        ])
      ]))
}